export default {"src":"/_next/static/media/modern-bath.6d9d79e5.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};